// Source: SellingPointsSection. Values include intentional inline spacing.
const en = {
  "s1": "Self-host or fully managed",
  "s2": "Run Hardcharger in ",
  "s3": "your own cloud",
  "s4": " — your data and your keys never leave your infrastructure — or let us operate it for you. Same engine, your call.",
  "s5": "Benchmarks you can reproduce",
  "s6": "Powered by DuckDB — the",
  "s7": "#2 median hot-run on ClickBench",
  "s8": "'s single-node reference benchmark, ahead of Snowflake, BigQuery, Redshift & Databricks. A 1 TB workload derived from TPC-H runs in under 90 seconds for ",
  "s9": "Plugs into your stack",
  "s10": "Speaks Chargewire (HTTP + Arrow), ADBC, JDBC, JavaScript & Python; works with dbt, DuckLake, S3 and GCS. ",
  "s11": "Standard SQL",
  "s12": ", so your dashboards and queries come along.",
  "s13": "Open by default, no lock-in",
  "s14": "Apache-2.0, every feature included, and open table formats — ",
  "s15": "no proprietary storage",
  "s16": ". Roles, row policies, SSO and audit logging come in the free build: enterprise controls, minus the enterprise invoice.",
  "s17": "The same SQL. Half the bill.",
  "s18": "Hardcharger gives you warehouse-grade analytics without the warehouse-grade invoice — on open standards you control.",
  "s19": "The Half-Bill Guarantee",
  "s20": "Our engineers migrate your workloads and cut your warehouse compute bill by 50%+ — or you don't pay for the sprint.",
  "s21": "See how it works",
  "cost": "$0.09"
};
const pt: typeof en = {
  "s1": "Hospedagem própria ou totalmente gerenciada",
  "s2": "Execute o Hardcharger na ",
  "s3": "sua própria nuvem",
  "s4": " — seus dados e suas chaves nunca saem da sua infraestrutura — ou deixe a operação conosco. O mesmo mecanismo, você escolhe.",
  "s5": "Benchmarks que você pode reproduzir",
  "s6": "Baseado em DuckDB — a",
  "s7": "2ª melhor mediana com cache aquecido no ClickBench",
  "s8": ", o benchmark de referência em nó único, à frente de Snowflake, BigQuery, Redshift e Databricks. Uma carga de trabalho de 1 TB derivada do TPC-H roda em menos de 90 segundos por ",
  "s9": "Integra-se à sua stack",
  "s10": "Compatível com Chargewire (HTTP + Arrow), ADBC, JDBC, JavaScript e Python; funciona com dbt, DuckLake, S3 e GCS. ",
  "s11": "SQL padrão",
  "s12": ", para levar seus dashboards e consultas com você.",
  "s13": "Aberto por padrão, sem dependência de fornecedor",
  "s14": "Apache-2.0, todos os recursos incluídos e formatos de tabela abertos — ",
  "s15": "sem armazenamento proprietário",
  "s16": ". Papéis, políticas de linha, SSO e logs de auditoria vêm na versão gratuita: controles de nível empresarial, sem a fatura de nível empresarial.",
  "s17": "O mesmo SQL. Metade da conta.",
  "s18": "O Hardcharger oferece análises no nível de um data warehouse sem a fatura de um data warehouse, com padrões abertos que você controla.",
  "s19": "A garantia de metade da conta",
  "s20": "Nossos engenheiros migram suas cargas de trabalho e reduzem sua conta de computação do data warehouse em 50% ou mais — ou você não paga pelo sprint.",
  "s21": "Veja como funciona",
  "cost": "US$ 0,09"
};
export default { en, 'pt-BR': pt };
